import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementOtherSubjectsUsersAction} from '../action';

function* execute({payload: {otherSubjectId, searchText}}: SearchManagementOtherSubjectsUsersAction): SagaIterator {
    yield* put(adminAction.setLoading('getUsers', true));
    const response = yield* call(Api.searchOtherSubjectEmployees, {text: searchText}, {otherSubjectId});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOtherSubjectsUsers(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getUsers', false));
}

/** Runs the admin saga that searches users for the other-subject management form. */
export function* searchManagementOtherSubjectsUsersSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_OTHER_SUBJECTS_USERS', execute);
}
